import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { Flex, Heading, SegmentedControl, Text } from '@radix-ui/themes'
import { Ops } from '@willie/schemas'
import { MaterialReturnsTable } from '~/features/material-returns/components/MaterialReturnsTable'
import { useTRPC } from '~/utils/trpc'

const ALL = 'all'

interface ReturnsSearch {
  status?: Ops.MaterialReturns.MaterialReturnStatus
}

const ReturnsPage = () => {
  const trpc = useTRPC()
  const navigate = useNavigate({ from: Route.fullPath })
  const { status } = Route.useSearch()
  const returnsQuery = useQuery(trpc.ops.materialReturns.list.queryOptions({ status }))

  return (
    <Flex direction="column" gap="4">
      <Flex align="center" justify="between" gap="3">
        <Heading size="6">Material returns</Heading>
        <SegmentedControl.Root
          size="1"
          value={status ?? ALL}
          onValueChange={(value) =>
            navigate({ search: { status: Ops.MaterialReturns.materialReturnStatusSchema.safeParse(value).data } })
          }
        >
          <SegmentedControl.Item value="in_progress">In progress</SegmentedControl.Item>
          <SegmentedControl.Item value="received">Received</SegmentedControl.Item>
          <SegmentedControl.Item value={ALL}>All</SegmentedControl.Item>
        </SegmentedControl.Root>
      </Flex>

      {returnsQuery.isLoading ? (
        <Text color="gray">Loading…</Text>
      ) : returnsQuery.error ? (
        <Text color="red">{returnsQuery.error.message}</Text>
      ) : (
        <MaterialReturnsTable returns={returnsQuery.data ?? []} />
      )}
    </Flex>
  )
}

export const Route = createFileRoute('/returns/')({
  component: ReturnsPage,
  validateSearch: (raw: Record<string, unknown>): ReturnsSearch => ({
    status: Ops.MaterialReturns.materialReturnStatusSchema.safeParse(raw.status).data
  })
})
